import { ref } from 'vue';

// Shared so every CTA, on any page, opens the one address modal mounted in App.vue
const isAddressEntryOpen = ref(false);

export default function useAddressEntry() {
  const openAddressEntry = () => {
    isAddressEntryOpen.value = true;
  };

  const closeAddressEntry = () => {
    isAddressEntryOpen.value = false;
  };

  return { isAddressEntryOpen, openAddressEntry, closeAddressEntry };
}
